export default "__VITE_ASSET__CFgw1bhr__"